const emotions = [
    {
      "id": 1,
      "name": "Enraged",
      "description": "feeling uncontrollable anger; filled with rage",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 2,
      "name": "Furious",
      "description": "feeling extreme, explosive anger",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 3,
      "name": "Irate",
      "description": "feeling strong but controlled anger",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 4,
      "name": "Livid",
      "description": "feeling intense, simmering anger",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 5,
      "name": "Jealous",
      "description": "feeling threatened by the loss of a valued someone",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 6,
      "name": "Envious",
      "description": "feeling a desire to possess what someone else has",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 7,
      "name": "Contempt",
      "description": "feeling disdain or disrespect",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 8,
      "name": "Troubled",
      "description": "feeling mild but persistent unease",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 9,
      "name": "Repulsed",
      "description": "feeling strong disgust toward someone or something",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 10,
      "name": "Scared",
      "description": "feeling fear due to perceived danger or threat",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 11,
      "name": "Frightened",
      "description": "feeling intense or sudden fear",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 12,
      "name": "Terrified",
      "description": "feeling very frightened",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 13,
      "name": "Panicked",
      "description": "feeling fear that prevents reasonable thought and action",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 14,
      "name": "Overwhelmed",
      "description": "feeling completely overcome by thought or feeling",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 15,
      "name": "Overwrought",
      "description": "feeling intensely overwhelmed",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 16,
      "name": "Anxious",
      "description": "feeling worried and nervous about an uncertain outcome",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 17,
      "name": "Angry",
      "description": "feeling deeply irritated due to perceived injustice",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 18,
      "name": "Frustrated",
      "description": "feeling upset because of unresolved problems or unfulfilled desires",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 19,
      "name": "Worried",
      "description": "feeling troubled about what is or might be",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 20,
      "name": "Nervous",
      "description": "feeling jumpy and worried about an uncertain outcome",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 21,
      "name": "Embarrassed",
      "description": "feeling self-conscious confusion and distress",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 22,
      "name": "Jittery",
      "description": "feeling physically shaky or on edge, often from excess energy",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 23,
      "name": "Apprehensive",
      "description": "feeling fear or unease about the future",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 24,
      "name": "Stressed",
      "description": "feeling mentally or emotionally strained from demands exceeding available resources",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 25,
      "name": "Shocked",
      "description": "feeling a sudden mental or emotional disturbance",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 26,
      "name": "Annoyed",
      "description": "feeling angry irritation in reaction to something specific",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 27,
      "name": "Irritated",
      "description": "feeling annoyed or mildly angry, often due to discomfort or frustration",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 28,
      "name": "FOMO",
      "description": "fear of missing out on something that others are experiencing",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 29,
      "name": "Concerned",
      "description": "feeling of thoughtful unease about something or someone important",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 30,
      "name": "Peeved",
      "description": "feeling mildly annoyed or irritated",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 31,
      "name": "Uneasy",
      "description": "feeling a subtle sense that something might be wrong",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 32,
      "name": "Tense",
      "description": "feeling nervous tension",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 33,
      "name": "Confused",
      "description": "feeling perplexed, disconcerted, or disoriented",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 34,
      "name": "Restless",
      "description": "feeling unable to relax due to unease, boredom, or impatience",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 35,
      "name": "Pressured",
      "description": "feeling as if you are responsible for an important outcome",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 36,
      "name": "Anguished",
      "description": "feeling severe mental or emotional distress",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 37,
      "name": "Agitated",
      "description": "feeling restless and emotionally stirred up",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 38,
      "name": "Impatient",
      "description": "feeling restless under irritation, delay, or opposition",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 39,
      "name": "Frenzied",
      "description": "feeling profound excitement or emotional disturbance",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 40,
      "name": "Intimidated",
      "description": "feeling frightened or overpowered by someone or something",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 41,
      "name": "Upset",
      "description": "feeling emotionally disturbed, troubled or unhappy",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 42,
      "name": "Alarmed",
      "description": "feeling urgently worried, concerned, or frightened",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 43,
      "name": "Wired",
      "description": "feeling profound excitement or nervous energy",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 44,
      "name": "Fremdschämen",
      "description": "second-hand embarrassment (German)",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 45,
      "name": "Appalled",
      "description": "feeling shocked or dismayed by something unpleasant or horrifying",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 46,
      "name": "Resentful",
      "description": "feeling bitter due to perceived unfairness",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 47,
      "name": "Rejected",
      "description": "feeling as if your needs, presence, or attempts have been dismissed",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 48,
      "name": "Distressed",
      "description": "feeling deeply upset or anxious, often due to difficult circumstances",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 49,
      "name": "Frazzled",
      "description": "feeling deep physical or nervous fatigue and agitation",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 50,
      "name": "Exasperated",
      "description": "feeling intense irritation or annoyance",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 51,
      "name": "Antsy",
      "description": "feeling emotionally restless, often from impatience",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 52,
      "name": "Fidgety",
      "description": "feeling physically restless, often from boredom",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 53,
      "name": "Disconcerted",
      "description": "feeling mildly disturbed by an event or realization",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 54,
      "name": "Skeptical",
      "description": "feeling doubtful or mistrusting",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 55,
      "name": "Betrayed",
      "description": "feeling deeply hurt or let down by someone’s breach of trust",
      "category": "high_arousal_unpleasant_valence"
    },
    {
      "id": 56,
      "name": "Cheerful",
      "description": "feeling in good spirits, with a sense of joy",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 57,
      "name": "Energized",
      "description": "feeling lively and alert, with a sense of vitality",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 58,
      "name": "Excited",
      "description": "feeling a surge of heightened energy or eager anticipation",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 59,
      "name": "Surprised",
      "description": "feeling taken aback by something unexpected",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 60,
      "name": "Awe",
      "description": "the feeling of being in the presence of something vast and mysterious",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 61,
      "name": "Determined",
      "description": "feeling strong-willed and resolute to persevere",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 62,
      "name": "Eager",
      "description": "feeling impatient desire or interest",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 63,
      "name": "Curious",
      "description": "feeling desire or interest to investigate and learn",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 64,
      "name": "Focused",
      "description": "feeling attention towards a single idea or activity",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 65,
      "name": "Impassioned",
      "description": "feeling filled with passion or zeal",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 66,
      "name": "Playful",
      "description": "feeling joyful and lighthearted",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 67,
      "name": "Delighted",
      "description": "feeling pleased and joyful",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 68,
      "name": "Alive",
      "description": "feeling present, aware, and connected to life",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 69,
      "name": "Upbeat",
      "description": "feeling full of positive energy",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 70,
      "name": "Enthusiastic",
      "description": "feeling a lively and sustained interest towards something",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 71,
      "name": "Successful",
      "description": "feeling like you’ve achieved what you wanted or hoped for",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 72,
      "name": "Exhilarated",
      "description": "feeling profoundly happy and excited or elated",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 73,
      "name": "Thrilled",
      "description": "feeling extremely excited and joyful all of a sudden",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 74,
      "name": "Amazed",
      "description": "feeling great surprise or wonder about something",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 75,
      "name": "Joyful",
      "description": "feeling deep pleasure or delight related to something",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 76,
      "name": "Happy",
      "description": "feeling pleasure or satisfaction caused by something",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 77,
      "name": "Confident",
      "description": "feeling sure of and reliant on yourself",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 78,
      "name": "Wishful",
      "description": "feeling a hopeful longing for something desired",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 79,
      "name": "Creative",
      "description": "feeling able or inspired to create",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 80,
      "name": "Engaged",
      "description": "feeling fully involved and interested in something",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 81,
      "name": "Sanguine",
      "description": "feeling optimistic or hopeful, often in a difficult situation",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 82,
      "name": "Motivated",
      "description": "feeling a strong desire to do well or succeed",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 83,
      "name": "Productive",
      "description": "feeling like you are achieving goals or completing tasks",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 84,
      "name": "Inspired",
      "description": "feeling uplifted and motivated by something",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 85,
      "name": "Elated",
      "description": "feeling deeply joyful, proud, or exultant",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 86,
      "name": "Ecstatic",
      "description": "feeling overwhelmingly joyful and intensely excited",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 87,
      "name": "Giddy",
      "description": "feeling excited, lightheaded, or silly due to intense happiness or thrill",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 88,
      "name": "Empowered",
      "description": "feeling more confident and capable due to someone or something",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 89,
      "name": "Proud",
      "description": "feeling satisfaction in achievement, either your own or someone else's",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 90,
      "name": "Optimistic",
      "description": "feeling hope for the future",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 91,
      "name": "Challenged",
      "description": "feeling pushed to overcome difficulty or improve",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 92,
      "name": "Accomplished",
      "description": "feeling proud and satisfied from achieving something",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 93,
      "name": "Passionate",
      "description": "feeling deeply enthusiastic and emotionally invested",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 94,
      "name": "Zealous",
      "description": "feeling eagerness and enthusiastic interest in the pursuit of something",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 95,
      "name": "Adventurous",
      "description": "feeling ready to explore new experiences or challenges",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 96,
      "name": "Jubilant",
      "description": "feeling great happiness, often after a success",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 97,
      "name": "Exultant",
      "description": "feeling great joy or triumph",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 98,
      "name": "Charmed",
      "description": "feeling pleasantly captivated or delighted by something",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 99,
      "name": "Overjoyed",
      "description": "feeling intense joy and elation",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 100,
      "name": "Amused",
      "description": "feeling pleasantly entertained by something funny or enjoyable",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 101,
      "name": "Courageous",
      "description": "feeling bold with strength to venture or persevere",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 102,
      "name": "Stimulated",
      "description": "feeling energized and mentally engaged",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 103,
      "name": "Invigorated",
      "description": "feeling refreshed and reenergized",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 104,
      "name": "Electrified",
      "description": "feeling a sudden surge of excitement and energy",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 105,
      "name": "Ambitious",
      "description": "feeling strongly driven to achieve significant goals",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 106,
      "name": "Triumphant",
      "description": "feeling victorious and satisfied, often after overcoming a challenge",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 107,
      "name": "Blissful",
      "description": "feeling complete or profound happiness or joy",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 108,
      "name": "Bubbly",
      "description": "feeling cheerful, animated and lively; full of high spirits",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 109,
      "name": "Rhapsodic",
      "description": "feeling enthusiastically or extravagantly emotional",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 110,
      "name": "Radiant",
      "description": "feeling obviously joyful or happy; exuding positive energy",
      "category": "high_arousal_pleasant_valence"
    },
    {
      "id": 111,
      "name": "Disgusted",
      "description": "feeling aversion towards something or someone",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 112,
      "name": "Humiliated",
      "description": "feeling laid bare and ashamed in front of others",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 113,
      "name": "Pessimistic",
      "description": "feeling doubtful or negative about the future",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 114,
      "name": "Guilty",
      "description": "feeling responsible for a wrongdoing",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 115,
      "name": "Abandoned",
      "description": "feeling left without needed protection, care, or support",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 116,
      "name": "Miserable",
      "description": "feeling profound distress or unhappiness",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 117,
      "name": "Despair",
      "description": "feeling completely hopeless, with a sense that the situation is unchangeable",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 118,
      "name": "Hopeless",
      "description": "feeling no expectation of improvement, good or success",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 119,
      "name": "Numb",
      "description": "feeling emotionally disconnected, often with a hint of an unpleasant mood",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 120,
      "name": "Wistful",
      "description": "feeling yearning or desire tinged with melancholy",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 121,
      "name": "Vulnerable",
      "description": "feeling exposed to possible emotional or mental harm",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 122,
      "name": "Ashamed",
      "description": "feeling lower self-worth due to perceived flaws in your actions or character",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 123,
      "name": "Trapped",
      "description": "feeling stuck, as though there is no way out",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 124,
      "name": "Insecure",
      "description": "feeling uncertain or lacking confidence in yourself",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 125,
      "name": "Lost",
      "description": "feeling uncomfortably confused or directionless",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 126,
      "name": "Disconnected",
      "description": "feeling separate from someone or something else",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 127,
      "name": "Hesitant",
      "description": "feeling slow to act or proceed, as from fear, indecision, or unwillingness",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 128,
      "name": "Excluded",
      "description": "feeling unwanted and left out from a group or an activity",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 129,
      "name": "Alienated",
      "description": "feeling estranged from others or from society as a whole",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 130,
      "name": "Glum",
      "description": "feeling quietly displeased or disappointed",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 131,
      "name": "Burned out",
      "description": "feeling depleted as a result of excessive and prolonged stress",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 132,
      "name": "Spent",
      "description": "feeling extremely depleted, both physically and mentally",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 133,
      "name": "Forlorn",
      "description": "feeling sad and lonely because of isolation or desertion",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 134,
      "name": "Regretful",
      "description": "feeling remorse or sorrow for something done or not done",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 135,
      "name": "Disappointed",
      "description": "feeling sad because expectations weren’t met or hopes went unfulfilled",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 136,
      "name": "Disheartened",
      "description": "feeling low-spirited; experiencing loss of hope, enthusiasm, or courage",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 137,
      "name": "Down",
      "description": "feeling sad and low in energy",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 138,
      "name": "Sad",
      "description": "feeling unhappy about something",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 139,
      "name": "Discouraged",
      "description": "feeling a loss of confidence or enthusiasm for something",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 140,
      "name": "Lonely",
      "description": "feeling sad from being alone",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 141,
      "name": "Exhausted",
      "description": "feeling completely or almost completely depleted of all energy",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 142,
      "name": "Helpless",
      "description": "feeling like there is nothing you can do to improve a situation",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 143,
      "name": "Apathetic",
      "description": "feeling little or no interest, concern, or emotion",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 144,
      "name": "Disengaged",
      "description": "feeling a lack of focus, interest or involvement",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 145,
      "name": "Fatigued",
      "description": "feeling drained of strength and energy",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 146,
      "name": "Tired",
      "description": "feeling need for rest or sleep",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 147,
      "name": "Bored",
      "description": "feeling disengaged and motivated to be engaged yet unable to figure out how",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 148,
      "name": "Jaded",
      "description": "feeling lack of interest because of experiencing too much of something",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 149,
      "name": "Deflated",
      "description": "feeling a sudden loss of confidence or optimism",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 150,
      "name": "Dispirited",
      "description": "feeling a loss of hope or a decline in morale",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 151,
      "name": "Weary",
      "description": "feeling tired or lacking energy and enthusiasm",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 152,
      "name": "Dissatisfied",
      "description": "feeling that something is not as good as it should be",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 153,
      "name": "Isolated",
      "description": "feeling alone, whether by choice or circumstance",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 154,
      "name": "Bittersweet",
      "description": "feeling at once happy and sad about an event or situation",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 155,
      "name": "Indifferent",
      "description": "feeling lack of interest, enthusiasm, or concern for something",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 156,
      "name": "Lethargic",
      "description": "feeling unwilling and unable to do anything; experiencing extreme drowsiness",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 157,
      "name": "Melancholic",
      "description": "feeling deep sadness, often reflective in nature",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 158,
      "name": "Sluggish",
      "description": "feeling slow and energyless; not performing or reacting as well as usual",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 159,
      "name": "Blah",
      "description": "feeling boredom or general dissatisfaction, typically with no apparent cause",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 160,
      "name": "Malaise",
      "description": "a general sense of discomfort, unease, or illness",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 161,
      "name": "Foggy",
      "description": "feeling confused and unable to think clearly",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 162,
      "name": "Stuck",
      "description": "feeling unable to bring about the change one wants",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 163,
      "name": "Despondent",
      "description": "feeling a loss of hope or courage, deeply discouraged",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 164,
      "name": "Languid",
      "description": "feeling a lack of energy or interest; slow and listless",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 165,
      "name": "Powerless",
      "description": "feeling devoid of strength or resources",
      "category": "low_arousal_unpleasant_valence"
    },
    {
      "id": 166,
      "name": "Calm",
      "description": "feeling peaceful, quiet, and without worry; a state of tranquillity",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 167,
      "name": "Good",
      "description": "feeling well, as if everything is as it should be",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 168,
      "name": "Relaxed",
      "description": "feeling at ease and comfortable",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 169,
      "name": "Sympathetic",
      "description": "feeling sorry for someone",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 170,
      "name": "Mellow",
      "description": "feeling relaxed and laid back; easygoing",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 171,
      "name": "Carefree",
      "description": "feeling free from care; having no worries or troubles",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 172,
      "name": "Tranquil",
      "description": "feeling peaceful, free from tension",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 173,
      "name": "Nostalgic",
      "description": "feeling longing for a past time or condition",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 174,
      "name": "Peaceful",
      "description": "feeling quiet and calm, untroubled by agitation",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 175,
      "name": "Abbiocco",
      "description": "drowsiness that sets in after a large meal (Italian)",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 176,
      "name": "Comfortable",
      "description": "feeling free from trouble, doubt, stress or tension",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 177,
      "name": "Chill",
      "description": "feeling laid back with an easy or cool demeanor",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 178,
      "name": "Thoughtful",
      "description": "feeling reflective about a situation, oneself, or others",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 179,
      "name": "At ease",
      "description": "feeling free from pain or discomfort",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 180,
      "name": "Understood",
      "description": "feeling seen and heard",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 181,
      "name": "Appreciated",
      "description": "feeling recognized and valued",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 182,
      "name": "Compassionate",
      "description": "feeling and showing concern for someone",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 183,
      "name": "Empathetic",
      "description": "momentarily sharing the feelings of someone",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 184,
      "name": "Balanced",
      "description": "feeling mental and emotional steadiness",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 185,
      "name": "Thankful",
      "description": "feeling relief or appreciation related to a specific event",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 186,
      "name": "Relieved",
      "description": "feeling at ease because something unpleasant was avoided or has ended",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 187,
      "name": "Pleased",
      "description": "feeling content and happy because something pleasant has happened",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 188,
      "name": "Safe",
      "description": "feeling secure from danger, harm, or loss",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 189,
      "name": "Content",
      "description": "feeling satisfied with how things are",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 190,
      "name": "Included",
      "description": "feeling accepted as part of a group",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 191,
      "name": "Steady",
      "description": "feeling consistently calm, without sudden shifts in mood",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 192,
      "name": "Supported",
      "description": "feeling like someone is standing by you",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 193,
      "name": "Respected",
      "description": "feeling admired for your qualities or achievements",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 194,
      "name": "Fulfilled",
      "description": "feeling like you are getting everything that you want from life",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 195,
      "name": "Loved",
      "description": "feeling deeply cared for",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 196,
      "name": "Valued",
      "description": "feeling recognized for your worth",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 197,
      "name": "Accepted",
      "description": "feeling welcomed for who you are or as part of a group",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 198,
      "name": "Secure",
      "description": "feeling safe and free from fear or doubt",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 199,
      "name": "Satisfied",
      "description": "feeling pleased with what has been experienced or received",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 200,
      "name": "Serene",
      "description": "feeling peaceful and calm, free of worries",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 201,
      "name": "Blessed",
      "description": "feeling fortunate to have something or experience something",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 202,
      "name": "Moved",
      "description": "feeling deeply affected by something inspirational or sad",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 203,
      "name": "Grateful",
      "description": "feeling enduring appreciation for someone or something",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 204,
      "name": "Connected",
      "description": "feeling close to others or something meaningful",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 205,
      "name": "Cozy",
      "description": "feeling snug and pleasantly comfortable",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 206,
      "name": "Refreshed",
      "description": "feeling reenergized, like after a restful break or fresh start",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 207,
      "name": "Settled",
      "description": "feeling comfortable and happy with where you are at",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 208,
      "name": "Composed",
      "description": "feeling in control of your thoughts and emotions in challenging situations",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 209,
      "name": "Grounded",
      "description": "feeling mentally and emotionally stable and present",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 210,
      "name": "Collected",
      "description": "feeling that your emotions and thoughts are gathered following initial agitation",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 211,
      "name": "Comforted",
      "description": "feeling emotionally or physically soothed in response to distress or pain",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 212,
      "name": "Reassured",
      "description": "feeling relieved from doubt, worry, fear, or uncertainty",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 213,
      "name": "Present",
      "description": "feeling fully engaged and aware in the current moment",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 214,
      "name": "Whole",
      "description": "feeling complete and fulfilled, as if nothing is missing",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 215,
      "name": "Nurtured",
      "description": "feeling cared for and supported",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 216,
      "name": "Hopeful",
      "description": "feeling a calm, positive expectation for the future",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 217,
      "name": "Placid",
      "description": "feeling serene calmness, undisturbed and quiet",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 218,
      "name": "Buoyant",
      "description": "feeling lightly optimistic and cheerful",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 219,
      "name": "Cherished",
      "description": "feeling deeply valued and cared for",
      "category": "low_arousal_pleasant_valence"
    },
    {
      "id": 220,
      "name": "Unrushed",
      "description": "the feeling of ease and freedom from urgency",
      "category": "low_arousal_pleasant_valence"
    }
  ];
  
  export default emotions;
  